const hasRole = (authorities, role) =>
  authorities.some((item) => item.authority === role);

const canAccess = (authorities, roles) =>
  roles.some((role) => hasRole(authorities, role));


export const buildNavigationSections = (authorities = []) => {
  const isOwner = hasRole(authorities, "OWNER");
  const isLogist = hasRole(authorities, "LOGIST");
  const isAccountant = hasRole(authorities, "ACCOUNTANT");
  const isAdmin = hasRole(authorities, "ADMIN");

  const sections = [
    ...(!isAccountant
      ? [
          {
            label: "Aдминка",
            icon: "pi pi-fw pi-briefcase",
            description: "Операционное управление логистикой",
            items: [
              {
                label: "Заказы",
                path: "/orders",
                icon: "pi pi-shopping-bag",
                description: "Создание и сопровождение отправлений",
              },
              {
                label: "Поставщики",
                path: "/postal_services",
                icon: "pi pi-truck",
                description: "Управление перевозчиками и сервисами",
              },
              {
                label: "Поставщики SLQ",
                path: "/slq_postal_services",
                icon: "pi pi-send",
                description: "Настройка сервисов для портала SLQ",
              },
              {
                label: "Категория товаров",
                path: "/product_categories",
                icon: "pi pi-tags",
                description: "Классификация товаров для расчетов",
              },
              {
                label: "ОКТРУ справочник по услугам",
                path: "/oktru_service_catalog",
                icon: "pi pi-book",
                description: "Справочник услуг по ОКТРУ для расчетов",
              },
              {
                label: "Направления",
                path: "/postal_routes",
                icon: "pi pi-map",
                description: "Маршруты и логистические плечи",
              },
              {
                label: "Калькулятор",
                path: "/calculator",
                icon: "pi pi-calculator",
                description: "Оценка тарифов и сроков доставки",
              },
              {
                label: "Калькулятор (разделённый по плечам)",
                path: "/calculator_shoulders",
                icon: "pi pi-share-alt",
                description: "Детализированный расчет по этапам",
              },
              {
                label: "Мониторинг статусов",
                path: "/status_monitoring",
                icon: "pi pi-chart-line",
                description: "Отслеживание этапов доставки",
              },
              {
                label: "Справочники",
                path: "/catalog",
                icon: "pi pi-book",
                description: "Базовые параметры и справочные данные",
              },
            ],
          },
        ]
      : []),
    {
      label: "SLQ Портал",
      icon: "pi pi-fw pi-link",
      description: "Пользователи и точки обслуживания",
      items: isAccountant
        ? [
            {
              label: "Пользователи",
              path: "/users",
              icon: "pi pi-users",
              description: "Управление пользователями портала",
            },
          ]
        : [
            {
              label: "Пользователи",
              path: "/users",
              icon: "pi pi-users",
              description: "Управление пользователями портала",
            },
            {
              label: "Терминалы ГП/Кросс-докинг",
              path: "/terminals",
              icon: "pi pi-building",
              description: "Сеть терминалов и локаций",
            },
            {
              label: "Терминалы перевозчиков",
              path: "/carrier-terminals",
              icon: "pi pi-building",
              description: "Терминалы в opostdb: приём и выдача груза, по ним строит пути граф",
            },
            {
              label: "Точки кросс-докинга",
              path: "/cross-docking-points",
              icon: "pi pi-sitemap",
              description: "Реестр кросс-докинга графа: перевозчик, сроки хранения, график",
            },
            {
              label: "Агентское вознаграждение",
              path: "/agent-reward",
              icon: "pi pi-percentage",
              description: "Реестр начислений агентского вознаграждения",
            },
          ],
    },
    ...(!isAccountant
      ? [
          {
            label: "Тарифы",
            icon: "pi pi-fw pi-chart-bar",
            description: "Настройка финансовых правил",
            items: [
              {
                label: "Администрирование тарифов",
                path: "/calc-tariffs",
                icon: "pi pi-sliders-h",
                description: "Управление тарифными сетками",
              },
                {
                    label: "Администрирование тарифов кросс-докинга",
                    path: "/cross-docking-tariffs",
                    icon: "pi pi-sliders-h",
                    description: "Управление тарифными сетками кросс-докинга",
                },
              {
                label: "Администрирование маржинальности",
                path: "/slq-tariffs",
                icon: "pi pi-sliders-h",
                description: "Управление тарифными сетками маржинальности",
              },
              {
                label: "Наценки калькулятора",
                path: "/org-tariffs",
                icon: "pi pi-percentage",
                description: "Наценки нового калькулятора, в т.ч. отключение наценки для PTC",
              },
               {
                label: "Администрирование РТК",
                path: "/market-tariffs",
                icon: "pi pi-map",
                description: "Рыночная тарифная карта",
              },
              {
                label: "Скидки и карты партнёров",
                path: "/partner-discounts",
                icon: "pi pi-percentage",
                description: "Тарифная карта и скидка партнёра по плечам доставки, например Halyk Market",
              },
              {
                label: "Тарифные карты",
                path: "/tariff-plans",
                icon: "pi pi-id-card",
                description: "Именованные тарифы на одно плечо для назначенных партнёров",
              },
              {
                label: "Закрытые направления",
                path: "/blocked-directions",
                icon: "pi pi-ban",
                description: "Направления, по которым расчёт не выполняется: глобально, партнёру или тарифной карте",
              },
              {
                label: "Заливка тарифов перевозчика",
                path: "/carrier-tariffs",
                icon: "pi pi-upload",
                description: "Загрузка тарифа из файла перевозчика с отчётом и контрольными точками",
              },
              {
                label: "Администрирование тарифов (новый калькулятор)",
                path: "/carrier-tariff-admin",
                icon: "pi pi-table",
                description: "Весовые лестницы по маршрутам и милям; старый экран остаётся для прежнего калькулятора",
              },
            ],
          },
        ]
      : []),
    ...(!isAccountant
      ? [
          {
            label: "Параметры",
            icon: "pi pi-fw pi-sliders-v",
            description: "Настраиваемые значения, общие для всего приложения",
            items: [
              {
                label: "Параметры приложения",
                path: "/app-settings",
                icon: "pi pi-cog",
                description: "Срок оплаты и лимит постоплаты АВР и прочие общие настройки",
              },
              ...(isAdmin
                ? [
                    {
                      label: "Организации API",
                      path: "/organizations",
                      icon: "pi pi-key",
                      description: "Партнёры по API: реквизиты, выпуск ключа и блокировка",
                    },
                  ]
                : []),
              {
                label: "Областные центры Казпочты",
                path: "/kazpost-regional-centers",
                icon: "pi pi-map-marker",
                description: "От списка зависит особая отметка 150/151 у отправлений EMS «Эконом» (P154)",
              },
            ],
          },
        ]
      : []),
    ...(isOwner && !isAccountant
      ? [
          {
            label: "Интеграции/Администрирование",
            icon: "pi pi-fw pi-cog",
            description: "Системные панели и контроль",
            items: [
              {
                label: "Панель",
                path: "/panel",
                icon: "pi pi-th-large",
                description: "Системный обзор и очереди",
              },
              {
                label: "DPD",
                path: "/panel/dpd",
                icon: "pi pi-bolt",
                description: "Управление интеграцией DPD",
              },
              {
                label: "Пользователи",
                path: "/panel/users",
                icon: "pi pi-id-card",
                description: "Администрирование учетных записей",
              },
              {
                label: "Аудит лог",
                path: "/panel/audit-logs",
                icon: "pi pi-file-edit",
                description: "Проверка системных событий",
              },
            ],
          },
        ]
      : []),
    ...(isOwner || isLogist
      ? [
          {
            label: "Биллинг",
            icon: "pi pi-fw pi-credit-card",
            description: "Учет и финансовые справочники",
            items: [
              {
                label: "Справочники по учету",
                path: "/billing/accounting-catalog",
                icon: "pi pi-wallet",
                description: "Справочники для биллинга",
              },
              {
                label: "Расчет оплаты услуг по ГПХ",
                path: "/billing/clc-payment-calculator",
                icon: "pi pi-calculator",
                description: "Расчет оплаты услуг по договорам ГПХ",
              },
              {
                label: "Журнал обязательств",
                path: "/billing/obligations-journal",
                icon: "pi pi-bookmark",
                description: "Просмотр и контроль журнала обязательств",
              },
            ],
          },
        ]
      : []),
  ];

  return sections;
};

export const toMenubarModel = (sections, onNavigate) =>
  sections.map((section) => ({
    label: section.label,
    icon: section.icon,
    items: section.items.map((item) => ({
      label: item.label,
      icon: item.icon,
      command: () => onNavigate(item.path),
    })),
  }));

export const getAccessibleModules = (authorities = []) => {
  const sections = buildNavigationSections(authorities);
  return sections.flatMap((section) =>
    section.items.map((item) => ({
      ...item,
      sectionLabel: section.label,
      sectionIcon: section.icon,
    }))
  );
};

export const hasRootAccess = (authorities = []) =>
  canAccess(authorities, ["ADMIN", "OWNER", "LOGIST", "SUPERUSER", "ACCOUNTANT"]);
